/**
 * Portal Amplitude event-name registry: maps a logical tracking key to its
 * Amplitude event name. Single source of truth shared by the adapter and the
 * host apps (fe-ccm tracking components).
 */
export const TRACK_EVENTS_MAP = {
    navigationButtonClicked: 'navigation_button_clicked',
    ccmDashboardViewed: 'ccm_dashboard_viewed',
    contentPreferencesMenuClick: 'content_preferences_menu_click',
    connectMenuClick: 'connect_menu_click',
    exploreMenuClick: 'explore_menu_click',
    historyMenuClick: 'history_menu_click',
    resourcesMenuClick: 'resources_menu_click',
    progressMenuClick: 'progress_menu_click',
    getCareButtonClicked: 'get_care_click',
    ccmCoachingViewed: 'coaching_center_viewed',
    ccmWeightView: 'weight_onboarding_view',
    ccmWeightMetricsViewed: 'weight_metrics_screen_viewed',
    widgetsView: 'widgets_view',
    tdCardClick: 'td_card_click',
    viewAll: 'next_steps_view_all_click',
    allTasksView: 'all_tasks_view',
    allTasksClick: 'task_click',
    downloadAppView: 'download_app_view',
    downloadAppClick: 'download_app_click',
    taskDetailsView: 'task_details_view',
    taskOptionClick: 'task_option_click',
    taskCtaClick: 'task_cta_click',
    errorView: 'error_view',
    ccmFoodViewed: 'food_diary_screen_viewed',
    ccmBgMetricsViewed: 'bg_metrics_screen_viewed',
    ccmBpMetricsViewed: 'bp_metrics_screen_viewed',
    ccmConditionProfileView: 'condition_profile_view',
    ccmRemindersView: 'ccm_reminders_view',
    bodyCompositionView: 'body_composition_view',
    showAllDataClick: 'show_all_data_click',
    summaryReportClick: 'summary_report_click',
    summaryReportsClick: 'summary_reports_click',
    viewUserGuidesClick: 'view_user_guides_click',
    ccmCoachingClick: 'ccm_coaching_click',
    bodyCompositionInfoClick: 'body_composition_info_click',
    dateRangeSelect: 'date_range_select',
    bodyCompositionToggleClick: 'body_composition_toggle_click',
    bodyCompositionBenefitsClick: 'body_composition_benefits_click',
    shareSummaryReportConfirmClick: 'share_summary_report_confirm_click',
    shareSummaryReportCancelClick: 'share_summary_report_cancel_click',
    foodLogAddMealClick: 'food_log_add_meal_click',
    foodLogMultiItemFoodView: 'food_log_multi_item_food_view',
    foodLogSingleItemFoodView: 'food_log_single_item_food_view',
    foodLogSaveClick: 'food_log_save_click',
    foodLogSaveSuccessView: 'food_log_save_success_view',
    foodLogNutritionEditClick: 'food_log_nutrition_edit_click',
    foodLogEditFoodView: 'food_log_edit_food_view',
    foodLogServingUnitClick: 'food_log_serving_unit_click',
    foodLogNutritionInfoClick: 'food_log_nutrition_info_click',
    foodLogEditFoodCancelClick: 'food_log_edit_food_cancel_click',
    foodLogEditFoodSaveClick: 'food_log_edit_food_save_click',
    getAtHomeKitView: 'get_at_home_kit_view',
    getAtHomeKitSubmit: 'get_at_home_kit_submit',
    testKitFaqClick: 'test_kit_faq_click',

    // Programs / multi-benefit flow
    programsMenuClick: 'programs_menu_option_click',
    yourProgramsView: 'your_programs_view',
    ccmProgramClick: 'ccm_program_click',
    confirmProgramSwitchView: 'confirm_program_switch_view',
    confirmNewCoverageClick: 'confirm_new_coverage_click',
    cancelNewCoverageClick: 'cancel_new_coverage_click',
    confirmProgramCoverageView: 'confirm_program_coverage_view',
    ccmBenefitSwitcherClick: 'ccm_benefit_switcher_click',
    ccmBenefitSwitcherView: 'ccm_benefit_switcher_view',
    // CGM event mappings
    healthTrendsCardClick: 'health_trends_card_click',
    cgmScreenView: 'cgm_screen_view',
    cgmMobileDownloadClick: 'cgm_mobile_download_click',
    myDevicesView: 'my_devices_view',
    myDevicesCardClick: 'my_devices_card_click',
    glucoseDataView: 'glucose_data_view',
    glucoseDataTimeRangeClick: 'glucose_data_time_range_click',
    glucoseDataDateSelectorClick: 'glucose_data_date_selector_click',
    glucoseDataUnderstandTheseNumbersClick:
        'glucose_data_understand_these_numbers_click',
    glucoseDataChartTooltipClick: 'glucose_data_chart_tooltip_click',
    glucoseDataInsightCardClick: 'glucose_data_insight_card_click',
    glucoseDataDeviceAndAppsCardClick:
        'glucose_data_device_and_apps_card_click',
    healthSummaryReportView: 'health_summary_report_view',
    healthSummaryReportExportClick: 'health_summary_report_export_click',
    launchpadTaskClick: 'launchpad_task_click',
    careGuidePageView: 'activation_landing_page_screen_view',
    careGuideCtaClick: 'explore_teladoc_click',

    // Journey guidance onboarding flow
    onboardingContinueClick: 'onboarding_continue_click',
    onboardingSkipClick: 'onboarding_skip_click',
    onboardingBackClick: 'onboarding_back_click',
    onboardingBackgroundClick: 'onboarding_background_click',
    onboardingErrorView: 'onboarding_error_view',
    onboardingStepView: 'onboarding_step_view',
    onboardingWelcomeVideoClick: 'onboarding_welcome_video_click',
    onboardingWelcomeSupportClick: 'onboarding_welcome_support_click',
    onboardingDevicesPrivacyClick: 'onboarding_devices_privacy_click',
};
